import { useEffect, useRef } from 'react';

// Reuses the existing /api/ws/tasks WebSocket + 30s polling fallback
export const useLiveRefresh = (onRefresh, { types = ['kitchen_task_update'], intervalMs = 30000, enabled = true } = {}) => {
  const cbRef = useRef(onRefresh);
  cbRef.current = onRefresh;

  useEffect(() => {
    if (!enabled) return undefined;
    const wsUrl = process.env.REACT_APP_BACKEND_URL.replace('https://', 'wss://').replace('http://', 'ws://');
    let ws = null;
    let reconnect = null;
    let closed = false;
    const connect = () => {
      try {
        ws = new WebSocket(`${wsUrl}/api/ws/tasks`);
        ws.onmessage = (event) => {
          try {
            const data = JSON.parse(event.data);
            if (types.includes(data.type)) cbRef.current?.(data);
          } catch (err) { console.error('WS parse error:', err); }
        };
        ws.onclose = () => { if (!closed) reconnect = setTimeout(connect, 5000); };
        ws.onerror = () => {};
      } catch (err) { reconnect = setTimeout(connect, 5000); }
    };
    connect();
    const poll = setInterval(() => cbRef.current?.({ type: 'poll' }), intervalMs);
    const ping = setInterval(() => { if (ws?.readyState === WebSocket.OPEN) ws.send('ping'); }, 30000);
    return () => {
      closed = true;
      clearInterval(poll);
      clearInterval(ping);
      clearTimeout(reconnect);
      if (ws) ws.close();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, intervalMs]);
};
